import * as ko from 'knockout';

import { formatNumberOrDash } from '../utils';

ko.bindingHandlers['formattedNumber'] = {
  update: (element: Element, valueAccessor: () => KnockoutObservable<number | string> | number | string) => {
    element.textContent = formatNumberOrDash(ko.unwrap(valueAccessor()));
  },
};

ko.bindingHandlers['formattedCurrency'] = {
  update: (element: Element, valueAccessor: () => KnockoutObservable<number | string> | number | string) => {
    element.textContent = formatNumberOrDash(ko.unwrap(valueAccessor()), 2);
  },
};

ko.bindingHandlers['formattedInt'] = {
  update: (element: Element, valueAccessor: () => KnockoutObservable<number | string> | number | string) => {
    element.textContent = formatNumberOrDash(ko.unwrap(valueAccessor()), 0);
  },
};
